import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Apps from './pages/Apps';
import CreateApp from './pages/CreateApp';
import Register from './pages/Register';
import Debug from './pages/Debug';
import AppDetail from './pages/AppDetail';
import TaskProgress from './pages/TaskProgress';
import Home from './pages/Home';
import Templates from './pages/Templates';
import Docs from './pages/Docs';
import Profile from './pages/Profile';
import CanvasChat from './pages/CanvasChat';
import RunAppAlternative from './pages/RunAppAlternative';
import VersionList from './pages/VersionList';
import GeneratorPage from './pages/GeneratorPage';
import ApiDocsPage from './pages/ApiDocsPage';
import FlowPage from './pages/FlowPage';
import ModelConfig from './pages/ModelConfig';
import CodeGeneratorPage from './pages/CodeGeneratorPage';

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? <>{children}</> : <Navigate to="/login" />;
};

const AppRoutes: React.FC = () => {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/flow" element={<FlowPage />} />
        <Route
          path="/apps"
          element={
            <PrivateRoute>
              <Apps />
            </PrivateRoute>
          }
        />
        <Route
          path="/apps/create"
          element={
            <PrivateRoute>
              <CreateApp />
            </PrivateRoute>
          }
        />
        <Route
          path="/apps/debug/:appId"
          element={
            <PrivateRoute>
              <Debug />
            </PrivateRoute>
          }
        />
        <Route
          path="/apps/detail/:appId"
          element={
            <PrivateRoute>
              <AppDetail />
            </PrivateRoute>
          }
        />
        <Route path="/register" element={<Register />} />
        <Route path="/task-progress/:appId" element={<TaskProgress />} />
        <Route
          path="/templates"
          element={
            <PrivateRoute>
              <Templates />
            </PrivateRoute>
          }
        />
        <Route
          path="/docs"
          element={
            <PrivateRoute>
              <Docs />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />
        <Route
          path="/model-config"
          element={
            <PrivateRoute>
              <ModelConfig />
            </PrivateRoute>
          }
        />
        <Route
          path="/apps/canvas-chat"
          element={
            <PrivateRoute>
              <CanvasChat />
            </PrivateRoute>
          }
        />
        <Route
          path="/apps/run/:publishUuid/:userUuid?"
          element={<CanvasChat />}
        />
        <Route
          path="/apps/alternative/:publishUuid"
          element={<RunAppAlternative />}
        />
        <Route
          path="/apps/api-docs/:appId"
          element={
            <PrivateRoute>
              <ApiDocsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/code-generator"
          element={
            <PrivateRoute>
              <CodeGeneratorPage />
            </PrivateRoute>
          }
        />
      </Routes>
    </div>
  );
};

export default AppRoutes; 